/**
 * Klient napovedy adres Mapy.com — kit vrstva (krok C2).
 *
 * Puvodne zil v `apps/web-admin/src/lib/mapy.ts` (BLOK 5). Verejny web
 * (`apps/web-public`) potrebuje stejny nasepta, a zadani C2 zakazuje kopii —
 * proto je cisty fetch tady v kitu a obe aplikace ho jen volaji.
 *
 * Kit NECTE prostredi: klic je vzdy parametr. Kazda aplikace ma vlastni
 * `import.meta.env` a kit se nesmi vazat na jednu z nich.
 */
const SUGGEST_URL = 'https://api.mapy.com/v1/suggest';
const SUGGEST_TYPES = 'regional.address,regional.street,regional.municipality_part,regional.municipality';
/** Dlazdice Mapy.com; bez klice volajici padne na OSM (viz `MapPreview`). */
export function mapyTileUrl(apiKey) {
    return `https://api.mapy.com/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=${encodeURIComponent(apiKey)}`;
}
/**
 * Prazdne pole = zadny vysledek (i pri chybe site — napoveda se proste
 * zavre). Bez klice se nevola nic, takze se napoveda sama neukaze.
 */
export async function suggestAddress(query, signal, apiKey) {
    if (apiKey === '' || query.trim().length < 2)
        return [];
    const url = `${SUGGEST_URL}?lang=cs&limit=6&type=${SUGGEST_TYPES}&apikey=${encodeURIComponent(apiKey)}&query=${encodeURIComponent(query)}`;
    try {
        const res = await fetch(url, { signal });
        if (!res.ok)
            return [];
        const data = (await res.json());
        return (data.items ?? []).slice(0, 6).map((item) => ({
            name: item.name ?? '',
            label: item.label ?? '',
            location: item.location ?? '',
            position: typeof item.position?.lat === 'number' && typeof item.position.lon === 'number'
                ? { lat: item.position.lat, lon: item.position.lon }
                : null,
        }));
    }
    catch {
        return [];
    }
}
/**
 * Mapy.com `location` nese celou hierarchii vcetne staatu („Stredocesky
 * kraj, Cesko“) — produkt je jen pro CZ jurisdikci (10 §0), takze posledni
 * „, Cesko“/„, Ceska republika“ je sum a do nazvu zakazky (P3) nepatri.
 */
function stripCountrySuffix(location) {
    return location.replace(/(^|,\s*)(Česko|Česká republika)$/u, '');
}
export function suggestItemDisplayLabel(item) {
    const location = stripCountrySuffix(item.location);
    return location !== '' ? `${item.name}, ${location}` : item.name;
}
/**
 * RUIAN zaznamy -> navrhy naseptavace. Registr vraci JEDNU formatovanou
 * adresu, takze druhy radek navrhu je prazdny (`location: ''`).
 */
export function ruianSuggestItems(hits) {
    return hits.map((hit) => ({
        name: hit.formatted,
        label: hit.formatted,
        location: '',
        position: { lat: Number(hit.latitude), lon: Number(hit.longitude) },
        approximate: hit.approximate === true,
    }));
}
//# sourceMappingURL=mapy.js.map